const Register = () => import('./Register.vue')
const Login = () => import('./Login.vue')
const Forgot = () => import('./Forgot.vue')
const Reset = () => import('./Reset.vue')
const Terms = () => import('./Terms.vue')
const MustConfirm = () => import('./MustConfirm.vue')
const VerifyEmail = () => import('./VerifyEmail.vue')

export default { Register, Login, Forgot, Reset, Terms, MustConfirm, VerifyEmail }
